import React from 'react';

const wrapperStyles =
  window.innerWidth < 992 ? { padding: '0 1.5rem' } : { paddingRight: '2rem' };

const PrivacyContents = () => (
  <div style={wrapperStyles} className={'lakes-medium'}>
    <p className={'lakes-bold'}>
      JetSuite, Inc respects your right to privacy and is committed to
      protecting our customers’ personal information (also called for the
      purposes of this Privacy Policy "personal data"). This Privacy Policy
      summarizes our practices regarding information collection, use and
      disclosure practices for this Website (http://www.jetsuite.com).
    </p>

    <p className={'color-red text-uppercase font-mid lakes-bold'}>
      WHAT PERSONAL INFORMATION DO WE GATHER?
    </p>

    <p>
      We process personal data in accordance with the applicable laws and, to
      the extent applicable, with the European General Data Protection
      Regulation (GDPR). Personal data that we process may also be subject to
      contractual or professional confidentiality obligations applicable to us.
      <br />
      We process personal data for the following purposes (hereinafter the
      "Purposes") and legal bases:
      <br />
      <ol type={'a'}>
        <li>
          For the performance of contractual obligations
          <br />
          We collect and process personal data as necessary for the performance
          of a contract to which you or a related person is a party, or to carry
          out pre-contractual measures that occur as part of a request.
        </li>
        <li>
          For compliance with a legal obligation or in the public interest
          <br />
          We may be subject to various legal obligations which require us to
          process and collect personal data, including in relation to the
          provision of information about products and services, the recording of
          phone conversations, the satisfaction of any requirements of
          cooperation with, or reporting to, any competent public prosecution,
          supervisory, administrative or tax authority or court, as well as the
          assessment and management of risks.
        </li>
        <li>
          For the purposes of safeguarding legitimate interests
          <br />
          When necessary, we process your personal data for the purpose of the
          legitimate interests pursued by us or a third party, if such
          processing does not unduly affect your interest or fundamental rights
          and freedoms. Examples include the development of our business
          relationship with you, the market studies and advertising, unless you
          have objected to the use of your data for marketing, the recording of
          phone conversations to verify instructions, improve the quality of our
          services or to safeguard our rights, the exercise or defense of actual
          or potential legal claims, or the conduct of investigations or similar
          proceedings, review and improvement of our internal processes and
          organization, the evaluation of certain characteristics of data
          subject on the basis of automatic processing of personal data (e.g.
          analytical tools).
        </li>
        <li>
          On the basis of your consent
          <br />
          To the extent that the processing of your personal data requires that
          you give your prior consent thereto, we will ask for your consent in
          due time. Any consent granted may be revoked at any time. Please be
          advised that the revocation of your consent shall only have effect for
          the future. Any processing that was carried out prior to the
          revocation shall not be affected thereby.
        </li>
      </ol>
      <p>
        The provision of personal data may be mandatory, for instance in
        connection with compliance with applicable laws and regulations. If the
        required data are not provided, this may preclude us from establishing
        or pursuing a business relationship or from rendering services to you.
      </p>
      <p>
        When you visit this Website, you may provide JetSuite with two types of
        information: personal data you knowingly and voluntarily choose to
        disclose, and personal data that we automatically collect as you browse
        this Website.
      </p>
    </p>
    <p>
      <span className={'lakes-bold'}>Information You Voluntarily Submit</span> –
      We collect and store any information you enter on this Website, or provide
      to JetSuite in other contacts we have with you. Information is collected
      from visitors to this Website, including in the areas described below, as
      applicable. You may change any of your personally identifiable information
      in your account online at any time. You may request to have the
      information on your account deleted or removed, although you cannot delete
      information associated with past purchases.
    </p>
    <p>
      <span className={'lakes-bold'}>Website Registration</span> – We collect IP
      addresses for the purposes of system administration, to gather broad
      demographic information, to potentially enable ads to be served on this
      Website, to report non-personally identifiable information to our
      advertisers, and to monitor the level of activity on this Website. We
      collect information from visitors to this Website regarding the URLs they
      visited, their IP addresses, domain types, the browser type used to come
      to this Website, the country, state and telephone area code where their
      servers are located, the pages of this Website that visitors viewed during
      their visit, the duration of their visit, and any search terms entered on
      this Website.
    </p>
    <p>
      <span className={'lakes-bold'}>Employment Applications</span> – The
      Careers section of this Website may allow you to submit information
      related to job opportunities with JetSuite. Please note that your
      submission of such information may be further governed by specific
      provisions that appear on any applicable employment opportunities sections
      of this Website.
    </p>
    <p>
      <span className={'lakes-bold'}>Online Surveys</span> – In order to improve
      our services to you, we ask some of our customers to voluntarily complete
      surveys, which may be collected by an independent third party. Individual
      survey answers are confidential, although non-personally identifiable
      information is collected and disclosed to third parties. If you do not
      wish to participate in a survey, simply decline to participate when asked.
    </p>
    <p>
      <span className={'lakes-bold'}>Contests and Sweepstakes</span> – When you
      enter a contest or other promotion, we may ask you for contact information
      such as your name, birthday, phone number, mailing address and e-mail
      address in order to administer the contest, to send you promotional
      e-mails, notify winners and make the winners’ list publicly available
      pursuant to certain states’ laws. Your consent to such promotional use and
      disclosure of this information is a condition of your participation. As a
      condition of receiving any prize, you will be required to submit an
      eligibility affidavit, for JetSuite to ensure that you are eligible to
      receive the prize according to the contest rules.
    </p>
    <p>
      <span className={'lakes-bold'}>Contact Information</span> – If you contact
      JetSuite by telephone, e-mail, social websites, or letter, or you submit
      this information via our newsletter signup page, quote request page or
      other page on this Website, we may keep a record of your correspondence,
      comments and/or any contact and/or trip information you provide. If you
      report a problem with this Website, we may collect such information in a
      file specific to you. If you contact JetSuite through our feedback area or
      by calling one of our customer service representatives, we may ask for
      your name, phone number and e-mail address in order to send you a reply.
      If other users or third parties send JetSuite correspondence about your
      activities on this Website, we may keep the information in a file specific
      to you. In the event we use a third party to help us provide customer
      service, we will provide them with your contact information.
    </p>
    <p>
      <span className={'lakes-bold'}>Advertising</span> – We may display
      advertisements on this Website in the form of targeted banners and
      promotions. JetSuite takes the advertisement and includes it in an
      JetSuite e-mail to prior customers meeting certain criteria. We may also
      display ads linked to certain search terms that you have entered, or to
      certain pages that you are viewing. In this process, advertisers never
      have access to individual account information; only JetSuite has access to
      individual’s accounts. Additionally, JetSuite may share aggregated data
      with advertisers.
    </p>
    <p>
      <span className={'lakes-bold'}>Newsletters</span> – We offer free
      newsletters and promotional e-mails as a service to our customers. We will
      send you newsletters and e-mails periodically listing current specials and
      deals. To stop receiving our newsletter, send an e-mail to us at
      opt-out@JetSuite.com or follow the opt-out procedures set forth in such
      newsletters or e-mails.
    </p>
    <p>
      <span className={'lakes-bold'}>
        Information Collected and Stored Automatically
      </span>{' '}
      – When you browse this Website, you and your Web browser may also transmit
      information that we automatically collect. We do log your IP address (the
      Internet address of your computer), the Web pages you visit and the time
      of your visit, and other click-stream data. This information may be
      combined with other personal information you have provided. The only other
      type of information automatically provided to JetSuite is the type of
      computer, operating system and browser you are using. This information is
      provided by your browser, which we use to improve the performance of this
      Website and make it more compatible with the technology used by the
      visitors of this Website. We may also place small data files, called
      “cookies,” in the browser file of your computer’s hard drive. These
      cookies automatically identify your browser to our server whenever you
      interact with this Website. We use the cookies to record Website
      statistics. Most browsers automatically accept the cookies, but you
      usually can change your browser setting to prevent the acceptance of
      cookies. Certain Web pages will not function properly if you choose not to
      accept cookies.
    </p>

    <p className={'color-red text-uppercase font-mid lakes-bold'}>
      How do we use your personal information?
    </p>
    <p>
      We use your personal information to communicate with you if and when
      necessary in connection with your use of this Website, to respond to your
      questions, or to send you material and information you request. We may
      also use your personal information to:
    </p>
    <p>
      <ol type={'a'}>
        <li>
          Personalize your Website experience and to allow JetSuite to deliver
          the type of content and product information in which you are most
          interested;
        </li>
        <li>Consider your suggestions;</li>
        <li>
          Possibly respond directly to you for clarification of questions
          raised;
        </li>
        <li>Process your request for materials or information;</li>
        <li>Try to answer any questions you may have;</li>
        <li>Book a trip for you;</li>
        <li>
          Register you for an event, contest or sweepstakes, if you request it;
        </li>
        <li>
          Provide you with e-mail messages and other information regarding
          upcoming events, new services and general information about our
          products and services and those of our select business partners.
        </li>
      </ol>
    </p>
    <p>
      You may elect not to receive these communications, either when you
      initially register at this Website, or at any time thereafter. See the
      section of this Privacy Statement below titled “CHOICE/OPT OUT”.
    </p>
    <p>
      We may also use collected information in order to help diagnose problems
      with this Website. We may use all information we collect to analyze
      statistical use patterns and demographic data (basically, where our
      visitors come from and what demographic characteristics they have) and to
      improve this Website to better serve our customers. We use your IP address
      to help diagnose problems with our servers, and to administer this
      Website. Your IP address is used to help identify you and to gather broad
      demographic information. We may also prepare and keep statistical records
      and other data about you and other users of this Website, but we do that
      in a way that does not identify you or any other user personally. We may
      hire third parties to help JetSuite collect and analyze such data, and we
      may share such statistical data with third parties. Again, such
      statistical data will not specifically identify you or any other user. We
      use this information to help us make this Website more useful to visitors
      -- to learn about the number of visitors to this Website, what part of
      this Website they are interested in, how long they use this Website, and
      the types of technology our visitors use.
    </p>
    <p className={'color-red text-uppercase font-mid lakes-bold'}>
      DISCLOSING YOUR PERSONAL INFORMATION TO OTHERS
    </p>
    <p>
      The personally identifiable information collected by JetSuite is used only
      for the limited purposes described in this Privacy Policy, including
      processing inquiries for products and services, for statistical purposes,
      for improving this Website and its performance, and to notify you of
      products or special offers that may be of interest to you.
    </p>
    <p>
      We will need to disclose your personally identifiable information to third
      parties to provide customer service and deliver promotional e-mails to you
      from JetSuite. In connection with these transactions, we collect data
      necessary to complete the transaction that is furnished by you. This
      information may be furnished to a third party in order to facilitate the
      transaction.
    </p>
    <p>
      We may disclose your information to our affiliates or service providers
      who assist JetSuite in operating this Website or conducting our business,
      including but not limited to Superior Air Charter and Delux Public
      Charter. We may also share such information among our subsidiaries and
      affiliates as necessary to provide you with the information and services
      you request or in which you may otherwise be interested.
    </p>
    <p>
      We may disclose information about you if and when we believe it is
      necessary to comply with any law, rule, court order, or subpoena, or to
      enforce our legal rights or the rules of this Website, or to protect our
      business, property and operations, or in connection with a sale,
      acquisition, merger or other business combination of our business with a
      third party. We may also disclose non-personally identifiable visitor
      information to other parties for marketing, advertising or other uses.
    </p>
    <p>
      Except in the limited circumstances stated in this section, we do not
      sell, rent, license, trade or otherwise disclose the personal information
      of visitors to this Website to unaffiliated third parties.
    </p>
    <p className={'color-red text-uppercase font-mid lakes-bold'}>
      LINKS TO OTHER SITES
    </p>
    <p>
      We may create links to other Websites that we think may be of interest to
      you. We do not endorse any other Websites, and this Privacy Policy applies
      only to your use of this Website. We have not reviewed the privacy
      policies of any Websites we link to this Website, and you should read the
      privacy policies of each Website you visit to determine what information
      about you that Website may collect and use.
    </p>
    <p className={'color-red text-uppercase font-mid lakes-bold'}>SECURITY</p>
    <p>
      Because we are committed to your privacy, we have put in place physical,
      electronic, and managerial procedures to attempt to safeguard and help
      prevent unauthorized access, maintain data security, and correctly use the
      personal information we collect online. When you access your personal
      information on this Website, we offer the use of a secure server. However,
      please remember that no transmission of data over the Internet or any
      wireless network can be guaranteed to be 100% secure. As a result, while
      we strive to protect your personal information, we cannot ensure or
      warrant the security of any information that you transmit to JetSuite or
      from us, and you do so at your own risk.
    </p>
    <p className={'color-red text-uppercase font-mid lakes-bold'}>
      DATA RETENTION
    </p>
    <p>
      As a matter of principle, we process and store your personal data as long
      as it is necessary in order to achieve the Purposes. We will delete or
      redact your personal data regularly once they are no longer necessary in
      order to achieve the Purposes, unless a further processing of your
      personal data is necessary for the following purposes: (i) compliance with
      longer records retention periods under applicable law or regulations and
      (ii) preservation of all forms of relevant information to exercise or
      defend actual or potential legal claims or to conduct investigations or
      similar proceedings.
    </p>
    <p className={'color-red text-uppercase font-mid lakes-bold'}>
      CUSTOMER RIGHTS ON THEIR PERSONAL DATA
    </p>
    <p>
      Subject to any applicable restrictions or requirements, you have the right
      to (i) request access to, and receive copy of, your personal data, (ii)
      request rectification of your personal data if they are inaccurate, (iii)
      request erasure of your personal data when the processing is not or no
      longer necessary for the Purposes, subject to applicable retention
      records, (iv) request a restriction of the processing of your personal
      data subject to the restrictions, (v) object to the processing of your
      personal data, in which case we will no longer process your personal data
      unless we have compelling legitimate grounds to do so and if applicable,
      (vi) receive your personal data in structured, commonly used and
      machine-readable format (data portability). You may exercise these rights
      by submitting a request to the following address: privacy@jetsuite.com. In
      addition, you have the right to be informed about the personal data stored
      and the purpose of the processing at any time. You may also lodge a
      complaint with the competent data protection supervisory authority if you
      believe that our processing of your personal data infringes applicable
      data protection laws.
    </p>
    <p className={'color-red text-uppercase font-mid lakes-bold'}>
      CHANGES IN OUR PRIVACY POLICY
    </p>
    <p>
      By using this Website, you consent to our collection and the use of your
      personal information as described in this Privacy Policy. If we change our
      Privacy Policy, we will post these changes on this Website. You have the
      opportunity to review this Privacy Policy each time you use this Website
      so that you are aware of any modifications made to these policies. We may
      also notify you any change in the manner deemed most appropriate.
    </p>
    <p className={'color-red text-uppercase font-mid lakes-bold'}>
      CHOICE/OPT OUT
    </p>
    <p>
      This Website provides users the opportunity to opt-out of receiving
      communications from JetSuite at the point where we request information
      about the visitor. You have the option of reviewing or removing your
      information from our database, and to no longer receive communication from
      us. If you request your account information be deleted from our database,
      we may maintain information about individual sales transactions for the
      purpose of recordkeeping and servicing.
    </p>

    <p>
      You can send your request via e-mail to opt-out@JetSuite.com, or by mail
      to the following postal address:
    </p>
    <p>
      JetSuite, Inc
      <br />
      1341 W Mockingbird Ln #600E, Dallas, TX 75247
    </p>
    <p>
      Please note that due to e-mail production schedules, you may receive an
      e-mail message from JetSuite after you have provided your opt-out notice.
    </p>

    <p className={'color-red text-uppercase font-mid lakes-bold'}>
      Questions about our Privacy Policy.
    </p>
    <p>
      If you have questions about this Website or JetSuite’s Privacy Policy,
      please feel free to contact us at privacy@jetsuite.com.
    </p>
    <p>
      This privacy policy is not a contract and does not create any legal rights
      or obligations.
    </p>
  </div>
);

export default PrivacyContents;



// WEBPACK FOOTER //
// ./src/components/Legal/Privacy/PrivacyContents.jsx